module.exports = __webpack_public_path__ + "images/agriculturehedging.svg?86e8b822b9d9db0d17cc947479df52fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/agriculturehedging.svg
// module id = aW57
// module chunks = 0